module.exports = __webpack_public_path__ + "img/FeatureMediaOverlay.b7e1477b.png";